export const getConfig = ({ config }) => config
export const getAuth = ({ auth }) => auth
export const getPersisted = ({ persisted }) => persisted
export const getLookups = ({ lookups }) => lookups
export const getPermissions = ({ permissions }) => permissions
export const getLivedata = ({ livedata }) => livedata
export const getUserConfig = ({ userConfig }) => userConfig
export const getSecurity = ({ security }) => security
export const getSystem = ({ system }) => system
export const getGrids = ({ grids }) => grids
export const getUtility = ({ utility }) => utility
export const getLogs = ({ logs }) => logs
export const getAML = ({ aml }) => aml
export const getCustomFields = ({ customFields }) => customFields
export const getLoan = ({ loan }) => loan
export const getRates = ({ rates }) => rates
export const getLoanOfficer = ({ loanOfficer }) => loanOfficer
export const getProduct = ({ product }) => product
export const getClient = ({ client }) => client
export const getOpDay = ({ opday }) => opday
export const getCollateral = ({ collateral }) => collateral
export const getAccount = ({ account }) => account
export const getUcc = ({ ucc }) => ucc
